// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Top-module--wrapper--17vOW"};